import React, { useState } from 'react';
import { useAssessment } from '../../context/AssessmentContext';

export default function BusinessForm({ onNext }) {
  const { businessInfo, setBusinessInfo } = useAssessment();
  const [formData, setFormData] = useState(businessInfo || {
    companyName: '',
    contactName: '',
    email: '',
    country: '',
    industry: '',
    employees: '',
    itProvider: '',
    sensitiveData: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setBusinessInfo(formData);
    onNext();
  };

  const inputClasses = "w-full p-4 bg-slate-950 border border-slate-800 rounded-xl text-white focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 outline-none transition-all placeholder:text-slate-600";
  const labelClasses = "block text-sm font-bold text-slate-400 mb-2 ml-1";

  return (
    <form onSubmit={handleSubmit} className="space-y-8">
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold text-white mb-3">Información de tu negocio</h2>
        <p className="text-slate-400">Para personalizar tu reporte, cuéntanos un poco sobre tu empresa.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <label className={labelClasses}>Nombre de la empresa</label>
          <input required type="text" name="companyName" value={formData.companyName} onChange={handleChange} className={inputClasses} placeholder="Ej. Mi Negocio S.A." />
        </div>
        <div>
          <label className={labelClasses}>Nombre de contacto</label>
          <input required type="text" name="contactName" value={formData.contactName} onChange={handleChange} className={inputClasses} placeholder="Tu nombre completo" />
        </div>
        <div>
          <label className={labelClasses}>Correo electrónico corporativo</label>
          <input required type="email" name="email" value={formData.email} onChange={handleChange} className={inputClasses} placeholder="nombre@empresa.com" />
        </div>
        <div>
          <label className={labelClasses}>País</label>
          <input required type="text" name="country" value={formData.country} onChange={handleChange} className={inputClasses} placeholder="Ej. México, Colombia..." />
        </div>
        <div>
          <label className={labelClasses}>Industria</label>
          <input required type="text" name="industry" value={formData.industry} onChange={handleChange} className={inputClasses} placeholder="Ej. Salud, Finanzas, Retail..." />
        </div>
        <div>
          <label className={labelClasses}>Número aprox. de empleados</label>
          <select required name="employees" value={formData.employees} onChange={handleChange} className={inputClasses}>
            <option value="">Selecciona una opción</option>
            <option value="1-10">1 - 10</option>
            <option value="11-50">11 - 50</option>
            <option value="51-200">51 - 200</option>
            <option value="200+">Más de 200</option>
          </select>
        </div>
      </div>

      <div className="pt-8 flex flex-col items-center gap-6 border-t border-slate-800">
        <button 
          type="submit" 
          className="w-full md:w-auto px-12 py-4 bg-blue-600 hover:bg-blue-500 text-white rounded-xl font-bold text-lg transition-all shadow-xl shadow-blue-600/20"
        >
          Continuar al diagnóstico
        </button>
        <p className="text-xs text-slate-500 text-center max-w-md">
          Al continuar, aceptas que tus datos serán tratados con total confidencialidad para generar tu reporte personalizado.
        </p>
      </div>
    </form>
  );
}